

















import { Component, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import { AppHeading, AppText } from '@/uikit';

@Component({
  components: {
    Button,
    AppText,
    AppHeading,
  },
})
export default class Message extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/components/message/Message.vue